import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./utils/language/i18n";
import { SupabaseUserProvider } from "./contexts/supabaseUser.context";
import { DataProvider } from "./contexts/DataContext";
import Home from "./pages/Home.page";
import Login from "./pages/Login.page";
import PrivateRoute from "./pages/PrivateRoute.page";
import Signup from "./pages/Signup.page";
import SuccessPage from "./pages/Success.page";
import CancelPage from "./comp/CancelPage";
import FinancePaymentSuccess from "./comp/FinancePaymentSuccess";
import FinancePaymentCancel from "./comp/FinancePaymentCancel";
import { PosShopPaymentSuccessWrapped as PosShopPaymentSuccess, PosShopPaymentCancelWrapped as PosShopPaymentCancel } from "./comp/user/PosShopPage";
import InvoicePage from "./pages/InvoicePage";
import InvoiceTermsPage from "./pages/InvoiceTermsPage";
import PasswordResetRequest from "./pages/PasswordResetRequest.page";
import PasswordReset from "./pages/PasswordReset.page";
import AnmalningLandingPage from "./pages/AnmalningLanding.page";
import AnmalningApplyPage from "./pages/AnmalningApply.page";
import AnmalningTrialFollowupPage from "./pages/AnmalningTrialFollowup.page";
import PrivacyPolicyPage from "./pages/PrivacyPolicy.page";
import DataDeletionPage from "./pages/DataDeletion.page";
import ScrollToTop from "./utils/components/ScrollToTop";
import { ThemeProvider } from "./contexts/ThemeContext";
/** Registers global API support-error reporting (apiClient + default axios). */
import "./utils/api/api";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <ScrollToTop />
      {/* We are wrapping our whole app with UserProvider so that */}
      {/* our user is accessible through out the app from any page */}
      <DataProvider>
        <SupabaseUserProvider>
          <ThemeProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/anmalning" element={<AnmalningLandingPage />} />
            <Route path="/anmalning/ansok" element={<AnmalningApplyPage />} />
            <Route path="/anmalning/prova-svar" element={<AnmalningTrialFollowupPage />} />
            <Route path="/success" element={<SuccessPage />} />
            <Route path="/cancel" element={<CancelPage />} />
            <Route path="/finance-payment-success" element={<FinancePaymentSuccess />} />
            <Route path="/finance-payment-cancel" element={<FinancePaymentCancel />} />
            <Route path="/shop-payment-success" element={<PosShopPaymentSuccess />} />
            <Route path="/shop-payment-cancel" element={<PosShopPaymentCancel />} />
            <Route path="/invoice/:token" element={<InvoicePage />} />
            <Route path="/invoice/:token/terms" element={<InvoiceTermsPage />} />
            <Route path="/invoice/:token/success" element={<InvoicePage />} />
            <Route path="/reset-password" element={<PasswordResetRequest />} />
            <Route path="/set-new-password" element={<PasswordReset />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/data-deletion" element={<DataDeletionPage />} />
            {/* We are protecting our Home Page from unauthenticated users by wrapping with PrivateRoute. */}
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Home />} />
              <Route path="/settings" element={<Navigate to="/?page=SettingsPage" replace />} />
              {/* Direct QR code access route */}
              <Route path="/qr/:studentID" element={<Home />} />
              {/* Simple redirect route (no student ID needed) */}
              <Route path="/qr/redirect" element={<Home />} />
            </Route>
          </Routes>
          </ThemeProvider>
        </SupabaseUserProvider>
      </DataProvider>
    </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;